import 'core-js/modules/es.object.assign.js';
import { colorTokens, aiTokens, gradientTokens } from './tokens.js';
import { deprecatedColorTokens, deprecatedGradientTokens } from './tokens-deprecated.js';

var Colors = Object.assign(Object.assign(Object.assign({}, colorTokens), aiTokens), deprecatedColorTokens);
var Gradients = Object.assign(Object.assign({}, gradientTokens), deprecatedGradientTokens);

export { Colors, Gradients };
